// extracted by mini-css-extract-plugin
export var noSpinners = "_nj-6";
export var percentageInput = "_nj-7";
export var variantColor1 = "_nj-0";
export var variantColor2 = "_nj-1";
export var variantColor3 = "_nj-2";
export var variantColor4 = "_nj-3";
export var variantColor5 = "_nj-4";
export var variantColor6 = "_nj-5";